import React from "react";
import { Heading, styled } from "@sourceful/shared-components";
import { SanityTechnicalContentItem } from "@sourceful/shared-types";
import InformationCard from "@components/informationCard";
import toRem from "@styles/postprocess/conversion/to-rem";

interface TechnicalContentInformationProps {
  item: SanityTechnicalContentItem;
}

export const InformationCardSectionWrapper = styled("div", {
  margin: "0 auto",
  marginTop: toRem(70),
  marginBottom: toRem(40),
  display: "flex",
  flexDirection: "column",
  rowGap: "$block_xl1",

  "@lg": {
    flexWrap: "wrap",
    flexDirection: "row",
    "> *": {
      flex: "0 0 50%",

      "&:nth-child(odd)": {
        pie: "$spacing-static-inline-m",
      },

      "&:nth-child(even)": {
        pis: "$spacing-static-inline-m",
      },
    },
  },
});

const TechnicalContentInformation = ({ item }: TechnicalContentInformationProps) => {
  const { title, isTitleHidden, informationCards } = item;

  return (
    <>
      {!isTitleHidden && (
        <Heading fontSize={4} level={3} css={{ textAlign: "center", marginTop: "60px" }}>
          {title}
        </Heading>
      )}

      <InformationCardSectionWrapper>
        {informationCards.map((item, index) => (
          <div style={{ padding: "20px" }} key={`${item._key}-${index}`}>
            <InformationCard informationCard={item} />
          </div>
        ))}
      </InformationCardSectionWrapper>
    </>
  );
};

export default TechnicalContentInformation;
